export const fileSideStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  minWidth: 0,
  padding: '12px',
  borderRadius: '8px',
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const factsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const checksumRowStyles = {
  display: 'flex',
  alignItems: 'flex-end',
  gap: '4px',
};
